import { Navigate, useParams } from 'react-router-dom'

export function RedirectToCamp() {
  const { campId } = useParams<{ campId: string }>()
  if (!campId) return <Navigate to="/camps" replace />
  return <Navigate to={`/camps/${campId}`} replace />
}
